// How much space should be between axis ticks?
export const PADDING = 10

// When text is vertical, what angle should it rotate at?
export const AXIS_DIAGONAL = 45

// How much should diagonal text height be skewed?
export const AXIS_DIAGONAL_SKEW = Math.sin(AXIS_DIAGONAL * (Math.PI / 180))

// How tall should each line of axis labels be?
export const LINE_HEIGHT = 20

// Fonts for labels and ticks
export const FONT_FAMILY = '"Whitney A", "Whitney B", sans-serif'
export const FONT_FAMILY_SERIF =
  '"Chronicle Display A", "Chronicle Display B", serif'
export const FONT_LARGE = '14px'
export const FONT_SMALL = '11px'

// What are the minimum allowable gutters?
export const MIN_TOP = PADDING
export const MIN_BOTTOM = 35
export const MIN_RIGHT = 25
export const MIN_LEFT = 25

// How much space should exist between the top and bottom of a label?
export const LABEL_PADDING = 15

// How much space should be alotted for horizontal ticks?
export const HORIZONTAL_TICK_HEIGHT = 16

// Should we explose chart line helpers?
export const CHART_DEBUG = window.location.toString().search('debug=true') >= 0

// Global animation kill switch
export const ANIMATE = window.location.toString().search('animate=false') <= 0

// Spring constants
export const PRECISION = 0.08
export const STIFFNESS = 130
export const DAMPING = 19
export const SPRING = {
  precision: PRECISION,
  stiffness: STIFFNESS,
  damping: DAMPING
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/constants.js